"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _WithTouch = _interopRequireDefault(require("../WithTouch"));

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var renderItem = function renderItem(Component) {
  return function (item, i) {
    return _react["default"].createElement(Component, {
      key: "listItem".concat(i, "_").concat(Math.random()),
      item: item
    });
  };
};

var UTList = function UTList(props) {
  var Component = props.component,
      items = props.items,
      onListEnd = props.onListEnd,
      loadBefore = props.loadBefore,
      onClick = props.onClick;

  var handleScroll = function handleScroll(e) {
    if (!e || !e.target) return;
    var limit = e.target.scrollHeight - e.target.offsetHeight - loadBefore;

    if (e.target.scrollTop >= limit) {
      return onListEnd ? onListEnd() : undefined;
    }
  };

  return _react["default"].createElement("div", {
    onScroll: handleScroll,
    className: _stylesModule["default"].list
  }, items && items.length > 0 && items.map(renderItem((0, _WithTouch["default"])(onClick)(Component))));
};

UTList.propTypes = {
  component: _propTypes.func.isRequired,
  items: (0, _propTypes.arrayOf)(_propTypes.any).isRequired,
  onListEnd: _propTypes.func,
  loadBefore: _propTypes.number,
  onClick: _propTypes.func
};
var _default = UTList;
exports["default"] = _default;